export default {
  Timer: '計時器',
  TimerStart: '開始計時',
  TimerPause: '暫停',
  TimerHour: '小時',
  TimerMinute: '分鐘',
  TimerSecond: '秒',
  TimerPaused: '已暫停',
  TimerResume: '繼續',
  TimerReset: '重設',
  TimerEnded: '時間已到',
  TimerSetPrompt: '請設定計時時間',
  TimerRunning: '計時器已開始',
  TimerMinuteLabel: '分鐘',
};

